(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $c04b6c6aa759ef5d$exports = {};

$parcel$export($c04b6c6aa759ef5d$exports, "initTheadAttributes", function () { return $c04b6c6aa759ef5d$export$8c232f4431fa1386; });
$parcel$export($c04b6c6aa759ef5d$exports, "initCellAttributes", function () { return $c04b6c6aa759ef5d$export$95460454ff19d469; });
$parcel$export($c04b6c6aa759ef5d$exports, "renderRows", function () { return $c04b6c6aa759ef5d$export$8aae65d4bebb157c; });
$parcel$export($c04b6c6aa759ef5d$exports, "addRow", function () { return $c04b6c6aa759ef5d$export$40ed00dbc18f8b2f; });
$parcel$export($c04b6c6aa759ef5d$exports, "updateRow", function () { return $c04b6c6aa759ef5d$export$b8d76db28fea00ae; });
function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


var $fea6c9abafe78b66$export$5191b7f1a2859b33 = {
    ADD: "add",
    UPDATE: "update",
    DELETE: "delete",
    SORT: "sort"
};
var $fea6c9abafe78b66$export$5bd128c043787deb = {
    MAX_AGE: 90,
    MIN_AGE: 18,
    MIN_NAME_LENGTH: 4,
    MIN_SALARY: 0
};
var $fea6c9abafe78b66$export$3d748083cb7ef6c4 = {
    SUCCESS: "success",
    ERROR: "error",
    WARNING: "warning"
};
var $fea6c9abafe78b66$export$c5db1fed33dc7d0b = "age";
var $fea6c9abafe78b66$export$7c22e256b97d4f33 = "salary";
var $fea6c9abafe78b66$export$6b9e7cecf28b64e8 = [
    $fea6c9abafe78b66$export$c5db1fed33dc7d0b,
    $fea6c9abafe78b66$export$7c22e256b97d4f33
];
var $fea6c9abafe78b66$export$6e386ac144cffab5 = "asc";
var $fea6c9abafe78b66$export$f634ff5a7f1c8f3 = "desc";
var $fea6c9abafe78b66$export$f9ba527e25c2bc92 = {
    NAME: "name",
    POSITION: "position",
    OFFICE: "office",
    AGE: "age",
    SALARY: "salary",
    ID: "id"
};
var $fea6c9abafe78b66$export$e6d6c3d190bf100b = [
    $fea6c9abafe78b66$export$f9ba527e25c2bc92.NAME,
    $fea6c9abafe78b66$export$f9ba527e25c2bc92.POSITION,
    $fea6c9abafe78b66$export$f9ba527e25c2bc92.OFFICE,
    $fea6c9abafe78b66$export$f9ba527e25c2bc92.AGE,
    $fea6c9abafe78b66$export$f9ba527e25c2bc92.SALARY
];
var $fea6c9abafe78b66$export$79b91d4669dcadcb = {
    NAME: "Name",
    POSITION: "Position",
    OFFICE: "Office",
    AGE: "Age",
    SALARY: "Salary"
};
var $fea6c9abafe78b66$export$217fe887316b1639 = {
    TOKYO: "Tokyo",
    SINGAPORE: "Singapore",
    LONDON: "London",
    NEW_YORK: "New York",
    EDINBURGH: "Edinburgh",
    SAN_FRANCISCO: "San Francisco"
};


var $c04b6c6aa759ef5d$export$8c232f4431fa1386 = function(theadElement, orderFields) {
    var tr = document.createElement("tr");
    orderFields.forEach(function(column) {
        var th = document.createElement("th");
        th.textContent = column[0].toUpperCase() + column.slice(1);
        th.dataset.field = column;
        th.tabIndex = 0;
        th.setAttribute("role", "button");
        tr.appendChild(th);
    });
    theadElement.innerHTML = "";
    theadElement.appendChild(tr);
};
var $c04b6c6aa759ef5d$export$95460454ff19d469 = function(tbody, rows, orderFields) {
    var frag = document.createDocumentFragment();
    (0, $227c6742e0ff6f82$export$71511d61b312f219)(rows).forEach(function(row, index) {
        var tr = document.createElement("tr");
        tr.dataset.id = index;
        (0, $227c6742e0ff6f82$export$71511d61b312f219)(row.children).forEach(function(td, idx) {
            var elementTd = document.createElement("td");
            elementTd.textContent = td.textContent;
            elementTd.dataset.field = orderFields[idx];
            tr.appendChild(elementTd);
        });
        frag.appendChild(tr);
    });
    tbody.innerHTML = "";
    tbody.appendChild(frag);
};
var $c04b6c6aa759ef5d$export$8aae65d4bebb157c = function(tbody) {
    var employeesArr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], orderFields = arguments.length > 2 ? arguments[2] : void 0;
    var frag = document.createDocumentFragment();
    employeesArr.forEach(function(employeeObj) {
        var tr = $c04b6c6aa759ef5d$export$40ed00dbc18f8b2f(employeeObj, orderFields);
        tr.dataset.id = employeeObj.id;
        frag.appendChild(tr);
    });
    tbody.innerHTML = "";
    tbody.appendChild(frag);
};
var $c04b6c6aa759ef5d$export$40ed00dbc18f8b2f = function(payload, orderFields) {
    var tbody = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var tr = document.createElement("tr");
    orderFields.forEach(function(field) {
        var td = document.createElement("td");
        if (field === (0, $fea6c9abafe78b66$export$f9ba527e25c2bc92).SALARY) td.textContent = "$" + payload[field].toLocaleString("en-US");
        else td.textContent = payload[field];
        td.dataset.field = field;
        tr.appendChild(td);
    });
    if (tbody) tbody.appendChild(tr);
    return tr;
};
var $c04b6c6aa759ef5d$export$b8d76db28fea00ae = function(payload, tbody) {
    var _tbody_querySelector;
    var td = (_tbody_querySelector = tbody.querySelector('[data-id="'.concat(payload.id, '"]'))) === null || _tbody_querySelector === void 0 ? void 0 : _tbody_querySelector.querySelector('[data-field="'.concat(payload.field, '"]'));
    if (td) td.textContent = payload.field === (0, $fea6c9abafe78b66$export$f9ba527e25c2bc92).SALARY ? "$" + payload.value.toLocaleString("en-US") : payload.value;
};


function $cd5a47cf8ef6d766$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}





function $ad1c00e896d27009$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $cd5a47cf8ef6d766$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $f17388ede13a49cc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f17388ede13a49cc$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $f17388ede13a49cc$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}



var $5e5c2391f073b1aa$export$2670b72d61fe3dbe = function(v) {
    var s = String(v !== null && v !== void 0 ? v : "").trim().replace(/\s+/g, "").replace(/['\u2019]/g, "");
    if (s === "") return s;
    var sign = s[0] === "-" ? "-" : "";
    if (sign) s = s.slice(1);
    var hasComma = s.includes(",");
    var hasDot = s.includes(".");
    s = hasComma ? s.split(",").filter(Boolean).join(",") : s;
    s = hasDot ? s.split(".").filter(Boolean).join(".") : s;
    if (hasComma && hasDot) {
        // last character is a fractional  separator
        var lastComma = s.lastIndexOf(",");
        var lastDot = s.lastIndexOf(".");
        if (lastComma > lastDot) // fractional comma
        s = s.replace(/\./g, "").replace(/,/g, ".");
        else // fractional point
        s = s.replace(/,/g, "");
        return sign + s;
    }
    if (hasComma && !hasDot) {
        var parts = s.split(",");
        var lastPart = parts[parts.length - 1];
        if (lastPart.length === 3) s = s.replace(/,/g, "");
        else s = s.replace(/,/g, ".");
        return sign + s;
    }
    if (hasDot && !hasComma) {
        var parts1 = s.split(".");
        if (parts1.length > 1) {
            var last = parts1.pop();
            if (last.length === 3) // all points are thousands
            s = parts1.join("") + last;
            else // the last one is fractional
            s = parts1.join("") + "." + last;
        }
        return sign + s;
    }
    return sign + s;
};


var $1889062e5425e153$var$required = function() {
    var msg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "field is required";
    return function(v) {
        return v === null || v === undefined || String(v) === "" ? msg : null;
    };
};
var $1889062e5425e153$var$minLen = function(len) {
    var msg = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "min length is ".concat(len);
    return function(v) {
        return String(v || "").trim().length >= len ? null : msg;
    };
};
var $1889062e5425e153$var$isInteger = function() {
    var msg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "must be an integer";
    return function(v) {
        if (v === "" || v === null) return null;
        var n = Number(String(v).trim());
        return Number.isFinite(n) && Number.isInteger(n) ? null : msg;
    };
};
var $1889062e5425e153$var$inRange = function(min, max) {
    var msg = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "value must be between ".concat(min, " - ").concat(max);
    return function(v) {
        if (v === "" || v === null) return null;
        var n = Number(String(v).trim());
        return Number.isFinite(n) && n >= min && n <= max ? null : msg;
    };
};
var $1889062e5425e153$var$isNormalizedNumber = function() {
    var msg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "must be a number";
    return function(v) {
        if (v === "" || v === null) return null;
        var normalized = (0, $5e5c2391f073b1aa$export$2670b72d61fe3dbe)(v);
        var n = Number(normalized);
        return Number.isFinite(n) ? null : msg;
    };
};
var $1889062e5425e153$var$isNonNegativeNumber = function() {
    var msg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "must be a positive number";
    return function(v) {
        if (v == null || v === "") return null;
        var normalized = (0, $5e5c2391f073b1aa$export$2670b72d61fe3dbe)(v);
        var n = Number(normalized);
        return Number.isFinite(n) && n >= 0 ? null : msg;
    };
};
var $1889062e5425e153$var$inList = function(list) {
    var msg = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Incorrect option";
    if (Array.isArray(list)) return function(v) {
        return list.includes(v) ? null : msg;
    };
    return function(v) {
        return Object.values(list).includes(v) ? null : msg;
    };
};
var $1889062e5425e153$export$6f0adf80117cb8df = {
    name: [
        $1889062e5425e153$var$required("Name is required"),
        $1889062e5425e153$var$minLen((0, $fea6c9abafe78b66$export$5bd128c043787deb).MIN_NAME_LENGTH, "Minimum name length is ".concat((0, $fea6c9abafe78b66$export$5bd128c043787deb).MIN_NAME_LENGTH))
    ],
    position: [
        $1889062e5425e153$var$required("Position is required")
    ],
    office: [
        $1889062e5425e153$var$required("Office is required"),
        $1889062e5425e153$var$inList((0, $fea6c9abafe78b66$export$217fe887316b1639), "Invalid office name")
    ],
    age: [
        $1889062e5425e153$var$required("Age is required"),
        $1889062e5425e153$var$isInteger("Age must be an integer"),
        $1889062e5425e153$var$inRange(18, 90, "Age must be between 18 and 90")
    ],
    salary: [
        $1889062e5425e153$var$required("Salary is required"),
        $1889062e5425e153$var$isNormalizedNumber("Salary must be a valid number"),
        $1889062e5425e153$var$isNonNegativeNumber("Salary must be non negative number")
    ]
};


var $880eafa2abb40257$export$610643b94c99336e = function(formData) {
    var errors = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys((0, $1889062e5425e153$export$6f0adf80117cb8df))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var field = _step.value;
            var validators = (0, $1889062e5425e153$export$6f0adf80117cb8df)[field];
            var fieldName = formData[field];
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = validators[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var fn = _step1.value;
                    var _$err = fn(fieldName);
                    if (_$err && !errors[field]) errors[field] = _$err;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var valid = Object.keys(errors).length === 0;
    var cleanedData = valid ? formData : null;
    return {
        valid: valid,
        errors: errors,
        cleanedData: cleanedData
    };
};
var $880eafa2abb40257$export$7d724175a602d186 = function(param) {
    var field = param.field, finalValue = param.finalValue;
    var errors = (0, $1889062e5425e153$export$6f0adf80117cb8df)[field].reduce(function(acc, rule, idx) {
        var error = rule(finalValue);
        if (error) return (0, $f17388ede13a49cc$export$71511d61b312f219)((0, $ad1c00e896d27009$export$71511d61b312f219)({}, acc), (0, $cd5a47cf8ef6d766$export$71511d61b312f219)({}, field + "_error-".concat(idx + 1), error));
        return (0, $ad1c00e896d27009$export$71511d61b312f219)({}, acc);
    }, {});
    var valid = Object.keys(errors).length === 0;
    return {
        valid: valid,
        errors: errors,
        newEmployeeField: finalValue
    };
};


var $31b303f33f7764fa$export$f7dc72e91f29c7d7 = function(type, title) {
    var text = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", timeout = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 4000;
    var prev = document.querySelector('[data-qa="notification"]');
    if (prev) prev.remove();
    var notification = document.createElement("div");
    notification.dataset.qa = "notification";
    notification.className = "notification ".concat(type);
    var h = document.createElement("h2");
    notification.appendChild(h);
    h.textContent = title;
    h.className = "title";
    if (text) {
        var p = document.createElement("p");
        p.textContent = text;
        p.style.whiteSpace = "pre-wrap";
        notification.appendChild(p);
    }
    var form = document.querySelector(".new-employee-form");
    var rect = form.getBoundingClientRect();
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var distanceFromViewportTopToFormBottom = rect.bottom + scrollTop + "px";
    var distanceFromViewportTopToFormLeft = rect.left + "px";
    notification.style.top = distanceFromViewportTopToFormBottom;
    notification.style.left = distanceFromViewportTopToFormLeft;
    notification.style.marginTop = "10px";
    document.body.appendChild(notification);
    var t = setTimeout(function() {
        notification.remove();
    }, timeout);
    notification.addEventListener("click", function() {
        clearTimeout(t);
        setTimeout(function() {
            return notification.remove();
        }, 150);
    });
};


var $ffdf4f3e5eeb940a$var$commitCellEdit = function(tableStore, updateEmployee) {
    var editor = tableStore.getActiveEditor();
    if (!editor) return;
    var td = editor.td, input = editor.input, oldValue = editor.oldValue;
    var newValue = input.value;
    if (newValue === oldValue) {
        td.textContent = oldValue;
        return;
    }
    var finalValue = typeof newValue === "string" ? newValue.trim() : newValue;
    var field = td.dataset.field;
    var _validateEmployeeFiled = (0, $880eafa2abb40257$export$7d724175a602d186)({
        field: field,
        finalValue: finalValue
    }), valid = _validateEmployeeFiled.valid, errors = _validateEmployeeFiled.errors;
    if (!valid) {
        (0, $31b303f33f7764fa$export$f7dc72e91f29c7d7)((0, $fea6c9abafe78b66$export$3d748083cb7ef6c4).ERROR, "Validation " + (0, $fea6c9abafe78b66$export$3d748083cb7ef6c4).ERROR, Object.values(errors).join(". \n") + ".");
        td.textContent = oldValue;
        return;
    }
    if (valid) (0, $31b303f33f7764fa$export$f7dc72e91f29c7d7)((0, $fea6c9abafe78b66$export$3d748083cb7ef6c4).SUCCESS, "Validation " + (0, $fea6c9abafe78b66$export$3d748083cb7ef6c4).SUCCESS, "Employee field " + field + " updated");
    if (finalValue === "") {
        td.textContent = oldValue;
        return;
    }
    if (field === (0, $fea6c9abafe78b66$export$c5db1fed33dc7d0b) || field === (0, $fea6c9abafe78b66$export$7c22e256b97d4f33)) {
        var finalNumber = Number(finalValue);
        if (Number.isNaN(finalNumber)) {
            td.textContent = oldValue;
            return;
        }
        if (field === (0, $fea6c9abafe78b66$export$c5db1fed33dc7d0b) && (finalNumber < 18 || finalNumber > 90)) {
            td.textContent = oldValue;
            return;
        }
        td.textContent = field === (0, $fea6c9abafe78b66$export$7c22e256b97d4f33) ? "$" + finalNumber.toLocaleString("en-US") : finalNumber;
        updateEmployee(td.closest("tr").dataset.id, (0, $cd5a47cf8ef6d766$export$71511d61b312f219)({}, field, finalNumber));
        return;
    }
    updateEmployee(td.closest("tr").dataset.id, (0, $cd5a47cf8ef6d766$export$71511d61b312f219)({}, field, finalValue));
};
var $ffdf4f3e5eeb940a$var$onKeyDown = function(e, tableStore) {
    var editor = tableStore.getActiveEditor();
    if (!editor) return;
    var td = editor.td, input = editor.input, oldValue = editor.oldValue;
    if (e.key === "Enter") input.blur();
    else if (e.key === "Escape") {
        td.textContent = oldValue;
        input.blur();
    }
};
var $ffdf4f3e5eeb940a$var$cleanup = function(tableStore) {
    var editor = tableStore.getActiveEditor();
    if (!editor) return;
    var handleBlur = editor.handleBlur, handleKeyDown = editor.handleKeyDown, input = editor.input, td = editor.td;
    if (input) {
        input.removeEventListener("keydown", handleKeyDown);
        input.removeEventListener("blur", handleBlur);
    }
    if (td && td.contains(input)) td.removeChild(input);
    tableStore.setActiveEditor(null);
};
var $ffdf4f3e5eeb940a$var$onBlur = function(tableStore, updateEmployee) {
    $ffdf4f3e5eeb940a$var$commitCellEdit(tableStore, updateEmployee);
    $ffdf4f3e5eeb940a$var$cleanup(tableStore);
};
var $ffdf4f3e5eeb940a$export$c45b319a69ac01cc = function(dblclickE, tableStore, updateEmployee) {
    var td = dblclickE.target.closest("td");
    if (!td || tableStore.getActiveEditor()) return;
    var oldValue = td.textContent;
    var input = document.createElement("input");
    input.className = "cell-input";
    if ((0, $fea6c9abafe78b66$export$6b9e7cecf28b64e8).includes(td.dataset.field)) input.type = "number";
    else input.type = "text";
    input.value = oldValue;
    td.textContent = "";
    td.appendChild(input);
    var handleBlur = function() {
        $ffdf4f3e5eeb940a$var$onBlur(tableStore, updateEmployee);
    };
    var handleKeyDown = function(e) {
        $ffdf4f3e5eeb940a$var$onKeyDown(e, tableStore);
    };
    tableStore.setActiveEditor({
        oldValue: oldValue,
        input: input,
        td: td,
        handleBlur: handleBlur,
        handleKeyDown: handleKeyDown
    });
    input.focus();
    input.select();
    input.addEventListener("blur", handleBlur);
    input.addEventListener("keydown", handleKeyDown);
};


var $b8ad82b0ddd5fc6a$var$handleTheadClick = function(e, tableState, getAllEmployeesSortedBy) {
    var th = e.target.closest("th");
    if (!th) return;
    var field = th.dataset.field;
    if (!field) return;
    tableState.setSort(field);
    getAllEmployeesSortedBy(field, tableState.getSort().direction);
};
var $b8ad82b0ddd5fc6a$var$handleTbodyClick = function(e, tableState, elements) {
    var tr = e.target.closest("tr");
    if (!tr) return;
    if (!tableState.getSelectedRowId()) {
        tableState.setSelectedRowId(tr.dataset.id);
        tr.classList.add("active");
        return;
    }
    var prev = elements.tbody.querySelector('tr[data-id="'.concat(tableState.getSelectedRowId(), '"]'));
    if (prev) prev.classList.remove("active");
    tr.classList.add("active");
    tableState.setSelectedRowId(tr.dataset.id);
};
var $b8ad82b0ddd5fc6a$export$2cd8252107eb640b = function(ctx) {
    var elements = ctx.elements, tableState = ctx.tableState, employeeStore = ctx.employeeStore;
    var updateEmployee = employeeStore.update, getAllSortedEmployeesBy = employeeStore.getAllSorted;
    elements.thead.addEventListener("click", function(e) {
        return $b8ad82b0ddd5fc6a$var$handleTheadClick(e, tableState, getAllSortedEmployeesBy);
    });
    elements.tbody.addEventListener("click", function(e) {
        return $b8ad82b0ddd5fc6a$var$handleTbodyClick(e, tableState, elements);
    });
    elements.tbody.addEventListener("dblclick", function(e) {
        return (0, $ffdf4f3e5eeb940a$export$c45b319a69ac01cc)(e, tableState, updateEmployee);
    });
};




function $5d4b947652f536c2$var$TableState() {
    this._sort = {
        field: null,
        direction: (0, $fea6c9abafe78b66$export$6e386ac144cffab5)
    };
    this._activeEditor = null;
    this._selectedRowId = null;
    var that = this;
    this.state = {
        getSort: function() {
            return that.getSort();
        },
        setSort: function(field) {
            return that.setSort(field);
        },
        getActiveEditor: function() {
            return that.getActiveEditor();
        },
        setActiveEditor: function(activeEditor) {
            return that.setActiveEditor(activeEditor);
        },
        getSelectedRowId: function() {
            return that.getSelectedRowId();
        },
        setSelectedRowId: function(selectedRowId) {
            return that.setSelectedRowId(selectedRowId);
        }
    };
}
$5d4b947652f536c2$var$TableState.prototype = {
    constructor: $5d4b947652f536c2$var$TableState,
    getSort: function() {
        return (0, $ad1c00e896d27009$export$71511d61b312f219)({}, this._sort);
    },
    setSort: function(field) {
        if (this._sort.field !== field) {
            this._sort.field = field;
            this._sort.direction = (0, $fea6c9abafe78b66$export$6e386ac144cffab5);
        } else this._sort.direction = this._sort.direction === (0, $fea6c9abafe78b66$export$6e386ac144cffab5) ? (0, $fea6c9abafe78b66$export$f634ff5a7f1c8f3) : (0, $fea6c9abafe78b66$export$6e386ac144cffab5);
    },
    getActiveEditor: function() {
        return this._activeEditor;
    },
    setActiveEditor: function(activeEditor) {
        this._activeEditor = activeEditor;
    },
    getSelectedRowId: function() {
        return this._selectedRowId;
    },
    setSelectedRowId: function(selectedRowId) {
        this._selectedRowId = selectedRowId;
    }
};
var $5d4b947652f536c2$var$state = new $5d4b947652f536c2$var$TableState();
var $5d4b947652f536c2$export$a524c460c77ad0e6 = $5d4b947652f536c2$var$state.state;



var $b51cc8f634e579d9$export$ed60ee4b8716ad1a = function(rows, orderFields) {
    return Array.from(rows).map(function(tr) {
        var dataObj = Array.from(tr.children).reduce(function(acc, td, idx) {
            var key = orderFields[idx];
            var value = td.textContent.trim();
            if ((0, $fea6c9abafe78b66$export$6b9e7cecf28b64e8).includes(key)) {
                var n = Number(value);
                acc[key] = Number.isFinite(n) ? n : value;
            } else acc[key] = value;
            return acc;
        }, {});
        return dataObj;
    });
};





var $8aa26d8538927c8a$export$6ab1df3197f7c641 = function(a, b, isNumeric) {
    if (isNumeric) return Number(a) - Number(b);
    return String(a).localeCompare(String(b), undefined, {
        sensitivity: "base"
    });
};



var $b7d696a98438b6a1$var$StoreProto = {
    getAll: function(acces) {
        return acces.getEmployees().map(function(emp) {
            return (0, $ad1c00e896d27009$export$71511d61b312f219)({}, emp);
        });
    },
    getById: function(acces, id) {
        return acces.getEmployees().find(function(emp) {
            return emp.id === id;
        }) || null;
    },
    add: function(acces, employee) {
        var newEmployee = (0, $f17388ede13a49cc$export$71511d61b312f219)((0, $ad1c00e896d27009$export$71511d61b312f219)({}, employee), {
            id: acces.nextId()
        });
        acces.pushEmployee(newEmployee);
        acces.emitChange((0, $fea6c9abafe78b66$export$5191b7f1a2859b33).ADD, newEmployee);
        return newEmployee;
    },
    update: function(id, fieldValue, acces) {
        var employees = acces.getEmployees();
        var idx = employees.findIndex(function(emp) {
            return emp.id === Number(id);
        });
        if (idx === -1) return null;
        var field = Object.keys(fieldValue)[0];
        var updated = (0, $ad1c00e896d27009$export$71511d61b312f219)({}, employees[idx], fieldValue);
        acces.replaceAt(idx, updated);
        acces.emitChange((0, $fea6c9abafe78b66$export$5191b7f1a2859b33).UPDATE, {
            field: field,
            value: updated[field],
            id: id
        });
    },
    remove: function(acces, id) {
        var idx = acces.getEmployees().findIndex(function(emp) {
            return emp.id === id;
        });
        if (idx === -1) return false;
        acces.removeAt(idx);
        acces.emitChange();
        return true;
    },
    getAllSorted: function(field, direction, acces) {
        var isNumeric = (0, $fea6c9abafe78b66$export$6b9e7cecf28b64e8).includes(field);
        var sorted = acces.getEmployees().slice().sort(function(emp1, emp2) {
            var v1 = emp1[field];
            var v2 = emp2[field];
            var cmp = (0, $8aa26d8538927c8a$export$6ab1df3197f7c641)(v1, v2, isNumeric);
            return direction === (0, $fea6c9abafe78b66$export$6e386ac144cffab5) ? cmp : -cmp;
        });
        acces.emitChange((0, $fea6c9abafe78b66$export$5191b7f1a2859b33).SORT, sorted);
    },
    subscribe: function(acces, fn) {
        return acces.subscribe(fn);
    },
    unsubscribe: function(acces, fn) {
        return acces.unsubscribe(fn);
    }
};
var $b7d696a98438b6a1$export$65d09ed15196c7e4 = function() {
    var initial = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var employees = initial.map(function(emp, idx) {
        return (0, $f17388ede13a49cc$export$71511d61b312f219)((0, $ad1c00e896d27009$export$71511d61b312f219)({}, emp), {
            id: idx,
            salary: Number((0, $5e5c2391f073b1aa$export$2670b72d61fe3dbe)(emp.salary).slice(1))
        });
    });
    var idCounter = employees.reduce(function(max, emp) {
        return Math.max(max, emp.id || 0);
    }, 0);
    var listeners = new Set();
    var acces = {
        getEmployees: function() {
            return employees;
        },
        pushEmployee: function(emp) {
            return employees.push(emp);
        },
        replaceAt: function(idx, emp) {
            employees[idx] = emp;
        },
        removeAt: function(idx) {
            return employees.splice(idx, 1);
        },
        nextId: function() {
            return ++idCounter;
        },
        emitChange: function(actionType, payload) {
            listeners.forEach(function(fn) {
                try {
                    fn({
                        type: actionType,
                        payload: payload
                    });
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.error(e);
                }
            });
        },
        subscribe: function(fn) {
            listeners.add(fn);
            return function() {
                return listeners.delete(fn);
            };
        },
        unsubscribe: function(fn) {
            return listeners.delete(fn);
        }
    };
    return {
        getAll: function() {
            return $b7d696a98438b6a1$var$StoreProto.getAll(acces);
        },
        getById: function(id) {
            return $b7d696a98438b6a1$var$StoreProto.getById(acces, id);
        },
        add: function(employee) {
            return $b7d696a98438b6a1$var$StoreProto.add(acces, employee);
        },
        update: function(id, fieldValue) {
            return $b7d696a98438b6a1$var$StoreProto.update(id, fieldValue, acces);
        },
        remove: function(id) {
            return $b7d696a98438b6a1$var$StoreProto.remove(acces, id);
        },
        getAllSorted: function(field, direction) {
            return $b7d696a98438b6a1$var$StoreProto.getAllSorted(field, direction, acces);
        },
        subscribe: function(fn) {
            return $b7d696a98438b6a1$var$StoreProto.subscribe(acces, fn);
        },
        unsubscribe: function(fn) {
            return $b7d696a98438b6a1$var$StoreProto.unsubscribe(acces, fn);
        }
    };
};







var $48caaf7b3d1ce3eb$var$SCHEMA = [
    {
        name: (0, $fea6c9abafe78b66$export$f9ba527e25c2bc92).NAME,
        label: (0, $fea6c9abafe78b66$export$79b91d4669dcadcb).NAME
    },
    {
        name: (0, $fea6c9abafe78b66$export$f9ba527e25c2bc92).POSITION,
        label: (0, $fea6c9abafe78b66$export$79b91d4669dcadcb).POSITION
    },
    {
        name: (0, $fea6c9abafe78b66$export$f9ba527e25c2bc92).OFFICE,
        label: (0, $fea6c9abafe78b66$export$79b91d4669dcadcb).OFFICE
    },
    {
        name: (0, $fea6c9abafe78b66$export$f9ba527e25c2bc92).AGE,
        label: (0, $fea6c9abafe78b66$export$79b91d4669dcadcb).AGE
    },
    {
        name: (0, $fea6c9abafe78b66$export$f9ba527e25c2bc92).SALARY,
        label: (0, $fea6c9abafe78b66$export$79b91d4669dcadcb).SALARY
    }
];
var $48caaf7b3d1ce3eb$var$normalizeFormData = function(cleanedData) {
    var _obj;
    return _obj = {}, (0, $cd5a47cf8ef6d766$export$71511d61b312f219)(_obj, (0, $fea6c9abafe78b66$export$f9ba527e25c2bc92).NAME, cleanedData[(0, $fea6c9abafe78b66$export$f9ba527e25c2bc92).NAME].trim()), (0, $cd5a47cf8ef6d766$export$71511d61b312f219)(_obj, (0, $fea6c9abafe78b66$export$f9ba527e25c2bc92).POSITION, cleanedData[(0, $fea6c9abafe78b66$export$f9ba527e25c2bc92).POSITION].trim()), (0, $cd5a47cf8ef6d766$export$71511d61b312f219)(_obj, (0, $fea6c9abafe78b66$export$f9ba527e25c2bc92).OFFICE, cleanedData[(0, $fea6c9abafe78b66$export$f9ba527e25c2bc92).OFFICE].trim()), (0, $cd5a47cf8ef6d766$export$71511d61b312f219)(_obj, (0, $fea6c9abafe78b66$export$f9ba527e25c2bc92).AGE, Number(cleanedData[(0, $fea6c9abafe78b66$export$f9ba527e25c2bc92).AGE])), (0, $cd5a47cf8ef6d766$export$71511d61b312f219)(_obj, (0, $fea6c9abafe78b66$export$f9ba527e25c2bc92).SALARY, Number((0, $5e5c2391f073b1aa$export$2670b72d61fe3dbe)(cleanedData[(0, $fea6c9abafe78b66$export$f9ba527e25c2bc92).SALARY]))), _obj;
};
var $48caaf7b3d1ce3eb$var$onSubmitForm = function(e, addEmployee) {
    e.preventDefault();
    var FORM_DATA = (0, $fea6c9abafe78b66$export$e6d6c3d190bf100b).reduce(function(acc, k) {
        acc[k] = document.querySelector('[name="'.concat(k, '"]')).value.trim();
        return acc;
    }, {});
    var _validateEmployeeData = (0, $880eafa2abb40257$export$610643b94c99336e)(FORM_DATA), valid = _validateEmployeeData.valid, errors = _validateEmployeeData.errors, cleanedData = _validateEmployeeData.cleanedData;
    if (!valid) {
        (0, $31b303f33f7764fa$export$f7dc72e91f29c7d7)((0, $fea6c9abafe78b66$export$3d748083cb7ef6c4).ERROR, "Validation " + (0, $fea6c9abafe78b66$export$3d748083cb7ef6c4).ERROR, Object.values(errors).join(". \n") + ".");
        return;
    }
    if (valid) {
        (0, $31b303f33f7764fa$export$f7dc72e91f29c7d7)((0, $fea6c9abafe78b66$export$3d748083cb7ef6c4).SUCCESS, "Validation " + (0, $fea6c9abafe78b66$export$3d748083cb7ef6c4).SUCCESS, "New employee saved");
        var employeeData = $48caaf7b3d1ce3eb$var$normalizeFormData(cleanedData);
        addEmployee(employeeData);
    }
};
var $48caaf7b3d1ce3eb$export$8f6e5b5e868af1d3 = function(addEmployee) {
    var form = document.createElement("form");
    form.className = "new-employee-form";
    $48caaf7b3d1ce3eb$var$SCHEMA.forEach(function(field) {
        var label = document.createElement("label");
        form.appendChild(label);
        label.appendChild(document.createTextNode("".concat(field.label, ": ")));
        if (field.name === (0, $fea6c9abafe78b66$export$f9ba527e25c2bc92).OFFICE) {
            var select = document.createElement("select");
            select.dataset.qa = field.name;
            select.required = true;
            select.name = field.name;
            var placeholder = document.createElement("option");
            select.appendChild(placeholder);
            placeholder.value = "";
            placeholder.textContent = "Select office...";
            Object.values((0, $fea6c9abafe78b66$export$217fe887316b1639)).forEach(function(office) {
                var option = document.createElement("option");
                select.appendChild(option);
                option.textContent = office;
                option.value = office;
            });
            label.appendChild(select);
            return;
        }
        var input = document.createElement("input");
        label.appendChild(input);
        input.dataset.qa = field.name;
        input.name = field.name;
        input.required = true;
        switch(field.name){
            case (0, $fea6c9abafe78b66$export$f9ba527e25c2bc92).AGE:
                input.min = (0, $fea6c9abafe78b66$export$5bd128c043787deb).MIN_AGE;
                input.max = (0, $fea6c9abafe78b66$export$5bd128c043787deb).MAX_AGE;
                break;
            case (0, $fea6c9abafe78b66$export$f9ba527e25c2bc92).SALARY:
                input.min = (0, $fea6c9abafe78b66$export$5bd128c043787deb).MIN_SALARY;
                break;
        }
        if ((0, $fea6c9abafe78b66$export$6b9e7cecf28b64e8).includes(field.name)) input.type = "number";
        else input.type = "text";
    });
    var button = document.createElement("button");
    button.textContent = "Save to table";
    button.type = "submit";
    button.addEventListener("click", function(e) {
        // // html validation
        // if (!form.checkValidity()) {
        //   form.reportValidity();
        //   return;
        // }
        return $48caaf7b3d1ce3eb$var$onSubmitForm(e, addEmployee);
    });
    form.appendChild(button);
    return form;
};



var $bb763a53bd8d3948$export$2cd8252107eb640b = function() {
    var thead = document.querySelector("thead");
    var tbody = document.querySelector("tbody");
    var orderFields = Array.from(thead.querySelectorAll("th")).map(function(th) {
        return th.textContent[0].toLowerCase() + th.textContent.slice(1);
    });
    $c04b6c6aa759ef5d$exports.initTheadAttributes(thead, orderFields);
    var employeeStore = (0, $b7d696a98438b6a1$export$65d09ed15196c7e4)((0, $b51cc8f634e579d9$export$ed60ee4b8716ad1a)(tbody.rows, orderFields));
    var add = employeeStore.add, update = employeeStore.update, getAllSorted = employeeStore.getAllSorted;
    var employeeForm = (0, $48caaf7b3d1ce3eb$export$8f6e5b5e868af1d3)(add);
    employeeStore.subscribe(function(param) {
        var type = param.type, payload = param.payload;
        switch(type){
            case (0, $fea6c9abafe78b66$export$5191b7f1a2859b33).UPDATE:
                $c04b6c6aa759ef5d$exports.updateRow(payload, tbody);
                break;
            case (0, $fea6c9abafe78b66$export$5191b7f1a2859b33).ADD:
                $c04b6c6aa759ef5d$exports.addRow(payload, orderFields, tbody);
                break;
            case (0, $fea6c9abafe78b66$export$5191b7f1a2859b33).SORT:
                $c04b6c6aa759ef5d$exports.renderRows(tbody, payload, orderFields);
                break;
        }
    });
    var ctx = {
        tableState: (0, $5d4b947652f536c2$export$a524c460c77ad0e6),
        elements: {
            thead: thead,
            tbody: tbody
        },
        employeeStore: {
            update: update,
            getAllSorted: getAllSorted
        },
        render: $c04b6c6aa759ef5d$exports
    };
    $c04b6c6aa759ef5d$exports.initCellAttributes(tbody, tbody.rows, orderFields);
    document.body.appendChild(employeeForm);
    $b8ad82b0ddd5fc6a$export$2cd8252107eb640b(ctx);
};


"use strict";
(0, $bb763a53bd8d3948$export$2cd8252107eb640b)();

})();
//# sourceMappingURL=index.407efdc1.js.map
